import React from "react";
import "./popup.scss";
import Cross from "../../assets/images/Cross.svg";

const AddNewAddressPopup = (props) => {
  return props.trigger ? (
    <div className="Main-PoupupDiv allADD">
      <div className="PopupMainCon ">
        {/* <div className="PopupMainCon-BG-Blur"></div> */}

        <div className="PopUpTextCon AllADD">
          <form onSubmit={props.onSubmitHandle}>
            <div className="AllADD-T">
              Add New Address{" "}
              <img
                onClick={() => {
                  props.setTrigger(false);
                  try {
                    props.setTrigger2(false);
                  } catch (error) {
                    // console.log('noTrigger2')
                  }
                }}
                src={Cross}
                alt=''
              />
            </div>

            <div className="addNewADD-item">
              <h1>Apartment No.</h1>
              <input
                type="text"
                value={props.AprtNo}
                onChange={props.handleChangeAprtNo}
              />
            </div>
            <div className="addNewADD-item">
              <h1>Street Address</h1>
              <input type="text"
               value={props.street}
                onChange={props.handleChangeStreet}
                 />
            </div>
            <div className="addNewADD-item">
              <h1>State</h1>
              <input type="text" value={props.State}
                onChange={props.handleChangeState} />
            </div>
            <div className="addNewADD-item">
              <h1>Zip Code</h1>
              <input type="number" value={props.Zip}
                onChange={props.handleChangeZip} />
            </div>
            <div className="addNewADD-item">
              <h1>City</h1>
              <input type="text" value={props.City}
                onChange={props.handleChangeCity} />
            </div>
            <div className="addNewADD-item">
              <h1>Country</h1>
              <input type="text" value={props.AddCountry}
                onChange={props.handleChangeAddCountry}/>
            </div>
            <button
              type="submit"
              // onClick={() => {
              //   props.setTrigger(false);
              //   try {
              //     props.setTrigger2(false);
              //   } catch (error) {
              //     // console.log('noTrigger2')
              //   }
              // }}
              className="AllADD-new-add save"
            >
              Save and add address
            </button>
          </form>
        </div>
        <div className="PopupBoxThird"></div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default AddNewAddressPopup;
